import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { BlockWrapper } from '../blockWrapper';
import { AccordionToggle } from './accordionToggle';
import { PortableTextBlock } from '@modules/portableTextBlock';

const Tab = ({ i, expanded, setExpanded, content, white }) => {
  const isOpen = i === expanded;
  return (
    <>
      <motion.div
        className='py-5 border-b flex flex-row justify-between items-center cursor-pointer'
        initial={false}
        onClick={() => setExpanded(isOpen ? false : i)}>
        <p className='text-base md:text-xl font-semibold'>{content.heading}</p>
        <AccordionToggle
          className='focus:outline-none'
          navOpen={isOpen}
          white={white}
        />
      </motion.div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            key='content'
            initial='collapsed'
            animate='open'
            exit='collapsed'
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}>
            <motion.div
              variants={{
                collapsed: { opacity: 0, scale: 1 },
                open: { opacity: 1, scale: 1 },
              }}
              transition={{ duration: 0.8 }}
              className='py-4'>
              {content.text && (
                <PortableTextBlock
                  className={`prose md:prose-lg ${
                    white ? 'text-white' : 'text-black'
                  }`}
                  text={content.text}
                />
              )}
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </>
  );
};

const Accordion = ({ blockConfig, dropdown, white, noGrid }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <BlockWrapper {...blockConfig} className='grid grid-cols-14'>
      <div
        className={
          noGrid
            ? 'col-start-1 col-end-15'
            : 'col-start-2 lg:col-start-4 col-end-14 lg:col-end-12'
        }>
        {dropdown.map((row, i) => (
          <Tab
            white={white}
            key={i}
            i={i}
            expanded={expanded}
            setExpanded={setExpanded}
            content={row}
          />
        ))}
      </div>
    </BlockWrapper>
  );
};

export default Accordion;
